import React from "react";
import Plans from "../component/plan/Plans";
import SearchSection from "../component/search/SearchSection";
import AboutUs from "../component/aboutUs/AboutUs";
import { Helmet } from "react-helmet";
import WelcomeModal from "../component/common/WelcomeModal";
import welcomeimage from '../assets/welcome-image.webp';
import playstore from '../assets/googleplay.webp';
import appstore from '../assets/appstore.webp';
import tireRepair from '../assets/tire-repair.svg';
import towingService from '../assets/towing-service.svg';


const HomePage = () => {

    return (
        <div className="main_content">
            <Helmet>
                <link rel="canonical" href="/" />
                <link rel="preload" href="https://fonts.gstatic.com/s/mulish/v17/1Ptvg83HX_SGhgqk3wot.woff2" as="font" type="font/woff2"
                    crossorigin="anonymous" />
                <link rel="preload"
                    href="https://fonts.googleapis.com/css2?family=Mulish:ital,wght@0,200..1000;1,200..1000&display=swap"
                    as="style" type="font/woff2" crossorigin="anonymous" />
                <link rel="preload" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.3/css/all.min.css" as="style" />

                <title>Emergency Roadside Truck & Trailer Repair – Open 24/7</title>
                <meta name="keywords" content="trailer repair shops,truck and trailer repair,truck repair near me,truck repair shops near me,semi trailer repair shop" />
                <meta name="description" content="Emergency? Our certified Truck & Trailer Repair pros are just a call away—day or night. Fast mobile response keeps you moving. Call now for trusted help!" />
                <meta property="og:title" content="Emergency Roadside Truck & Trailer Repair – Open 24/7" />
                <meta property="og:description" content="Emergency? Our certified Truck & Trailer Repair pros are just a call away—day or night. Fast mobile response keeps you moving. Call now for trusted help!" />
                <link rel="preload" as="image" href={welcomeimage} />
                <link rel="preload" as="image" href={appstore} />
                <link rel="preload" as="image" href={playstore} />

            </Helmet>

            <WelcomeModal />
            <SearchSection />
            <AboutUs />
            <Plans />

            {/* Extra Content Section */}

            <section className="services_highlight">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-md-11">
                            <div className="row">
                                <div className="col-md-12 mb-3 mb-md-5 key_ser_title">
                                    <h3 className="mb-2">Experience Innovation <br />That Feels <span>Effortless</span>, Yet <span>Unstoppable</span></h3>
                                    <p>Ready to Roll — Upgrade, Adapt, and Keep Growing..</p>
                                </div>

                                <div className="col-lg-12 col-md-12 col-12 mt-4">
                                    <div className="row justify-content-around">
                                        <div className="col-md-5 col-12 mb-2 mb-lg-5">
                                        <div className="keyword_service text-left h-100">
                                            <div class="keyword_icon bg-light-yellow">
                                            <i class="fas fa-truck"></i>
                                            </div>
                                            <h4>Truck Repair</h4>
                                            <p>Our team ensures precision in every repair, from engine diagnostics to
                                                brake and tire replacement. With nationwide coverage and rapid response
                                                times, help is always nearby. We treat every truck like our own — ensuring
                                                reliability, performance, and peace of mind.
                                            </p>
                                        </div>
                                        </div>

                                        <div className="col-md-5 col-12 mb-2 mb-lg-5">
                                        <div className="keyword_service text-left h-100">
                                            <div class="keyword_icon bg-light-red">
                                            <i class="fas fa-trailer"></i>
                                            </div>
                                            <h4>Trailer Repair</h4>
                                            <p>From brake systems and axles to lighting and suspension, we handle it all with
                                                precision and care. Our team works around the clock to minimize downtime and
                                                maximize performance. Every repair is done to last — ensuring your trailers
                                                are road-ready, compliant, and dependable mile after mile.
                                            </p>
                                        </div>
                                        </div>

                                       <div className="col-md-5 col-12 mb-2 mb-lg-5">
                                        <div className="keyword_service text-left h-100">
                                            <div class="keyword_icon bg-light-green">
                                            <img src={tireRepair} className="img-fluid" alt='Tire Repair' loading='lazy'/>
                                            </div>
                                            <h4>Tire Repair</h4>
                                            <p>Our expert technicians handle everything from blowouts to replacements with
                                                precision and care. Whether it’s day or night, our fully equipped service units
                                                ensure you’re never stranded. We use top-quality tires and tools to guarantee
                                                lasting performance. With Online Road Services, every mile you drive is backed
                                                by confidence and safety.
                                            </p>
                                        </div>
                                        </div>

                                       <div className="col-md-5 col-12 mb-2 mb-lg-5">
                                        <div className="keyword_service text-left h-100">
                                            <div class="keyword_icon bg-light-purple">
                                             <img src={towingService} className="img-fluid" alt='Towing Service' loading='lazy'/>
                                            </div>
                                            <h4>Towing Service</h4>
                                            <p>From light-duty to heavy-duty towing, we handle every situation with care and expertise.
                                                Our 24/7 response ensures help is always just a call away — day or night. With GPS-equipped trucks,
                                                professional drivers, and transparent pricing, Online Road Services delivers dependable towing
                                                when it matters most.
                                            </p>
                                        </div>
                                        </div>

                                      </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Extra Content Section */}


        </div>
    );
};

export default HomePage;